import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { DogoLogo } from './DogoLogo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <nav className={`fixed top-0 w-full z-[999] bg-black/95 backdrop-blur-[10px] border-b transition-colors duration-300 ${isScrolled ? 'border-brand-red' : 'border-brand-border'}`} data-id="element-140">
      <div className="max-w-[1200px] mx-auto px-8 flex items-center justify-between h-[70px]" data-id="element-141">
        <a href="#home" className="flex items-center gap-2.5 text-decoration-none" onClick={closeMenu} data-id="element-142">
          <DogoLogo size={42} data-id="element-143" />
          <span className="text-[1.4rem] font-extrabold text-brand-text tracking-[3px] uppercase" data-id="element-144">
            DOGOSELL
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden sm:flex list-none gap-10" data-id="element-145">
          {['Home', 'About', 'Contact'].map(item => <li key={item} data-id="element-146">
              <a href={`#${item.toLowerCase()}`} className="text-brand-muted text-[0.9rem] font-medium tracking-[1px] uppercase transition-colors duration-300 relative group hover:text-brand-text" data-id="element-147">
                {item}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-brand-red transition-all duration-300 group-hover:w-full" data-id="element-148"></span>
              </a>
            </li>)}
        </ul>

        {/* Mobile Hamburger */}
        <button className="sm:hidden flex flex-col gap-[5px] cursor-pointer bg-transparent border-none p-1 text-brand-text" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-149">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-150" /> : <MenuIcon size={28} data-id="element-151" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {isMobileMenuOpen && <div className="sm:hidden absolute top-[70px] left-0 right-0 bg-black/98 border-b border-brand-border py-4 flex flex-col" data-id="element-152">
          {['Home', 'About', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-8 py-3.5 border-b border-brand-border text-brand-muted uppercase tracking-[1px] font-medium hover:text-brand-text hover:bg-white/5 transition-colors" onClick={closeMenu} data-id="element-153">
              {item}
            </a>)}
        </div>}
    </nav>;
}